import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import Gallery from "../components/Gallery";
import BeforeAfterPairs from "../components/BeforeAfterPairs";
import ContactForm from "../components/ContactForm";

// Verbatim data for each page migrated from the scrape
const SERVICES_DATA = {
  rottespaerre: {
    title: "Rottespærre",
    slug: "rottespaerre",
    meta_title: "Rottespærre – FYNS AFLØBSTEKNIK",
    meta_description: "Fyns Afløbsteknik er autoriseret ekspert i rottesikring og montering af rottespærre i kloaksystemer.",
    hero_heading: "Rottestop med en rottespærre",
    hero_subheading: "Vi er eksperter i rottesikring",
    gallery_slug: "rottespaerre-galleri",
    badge: "Rottesikring",
    image: "https://assets.auxodev.dk/assets/3ee58f8c-8fdb-408d-9efa-3b231a487177/imgi-5-header-img-scaled.jpg",
    htmlContent: `
      <p>Har du mistanke om rotter i dine afløb eller i dit toilet? Det er ikke uden grund, at rotten er det mest velkendte skadedyr, vi har i Danmark. Rotten er både intelligent, atletisk og hurtigt formerende. Derfor er det helt essentielt, du er hurtigt ude med riven, hvis det pjuskede dyr inviterer sig selv på visit i dit ellers trygge hjem.</p>
      
      <h2>Fyns Afløbsteknik ApS: Autoriseret rottespærremontør</h2>
      <p>Hos Fyns Afløbsteknik ApS har vi mange års erfaring med at sikre de danske hjem mod rotter. Rotter udgør ikke blot en sundhedsfare, men medfører også store skader på dine kloakrør. I værste fald kan den pjuskede fætter undergrave dit hjem eller dine erhvervsbygninger.</p>
      <p>Det er her, Fyns Afløbsteknik ApS kommer ind i billedet. Ved at indsætte en rottespærre i dine kloakrør, afskærer vi rottens passage fuldstændigt. Det er vigtigt, rottespærren monteres så tæt på hovedledningen som overhovedet muligt, så den må vende om i god afstand til bygningen. Som autoriseret kloakmester kan Fyns Afløbsteknik ApS klare arbejdet for dig, så det bliver gjort helt rigtigt fra start.</p>
      <p>Vores fornemmeste opgave er at imødekomme dine forventninger ift. både topkvalitet og tillidsfuld service. Hos Fyns Afløbsteknik ApS er din kloakering i trygge hænder.</p>
      
      <h2>Hvorfor er rotter farlige?</h2>
      <p>Måske er læren om rotter ikke lige det emne, du ved mest om. Vil du forebygge et besøg fra skadedyret, kan det alligevel være meget brugbart at kende til dyrets færden.</p>
      <p>Hos Fyns Afløbsteknik ApS er vi naturligvis meget bevidste om rottens færden, men også om hvilke konsekvenser et uventet besøg kan have. Læs med herunder, og bliv klogere på, hvordan rottens invasion kan forebygges.</p>
      
      <h2>En skadelig atlet</h2>
      <p>Du kender sikkert udtrykket ”at formere sig som rotter”. Det er desværre ikke et udtryk, som florerer uden grund. Et rottepar kan under fordelagtige forhold reproducere mere end 800 rotter på et år. Fra befrugtning til fødsel går der 20-24 dage, og skadedyret kan føde op til 12 unger per kuld.</p>
      <p>I Danmark har vi flest brune rotter. Den brune rotte kan blive helt op til 55 centimeter fra snudetip til halespids. Samtidig kan den veje helt op til et halvt kilo. Til trods for denne klækkelige kampvægt, så er rotten særdeles smidig. Den kan både svømme, dykke og klatre på lod- og vandrette flader. Desuden kan den hoppe en hel meter lodret op i luften, smyge sig gennem et hul på kun to centimeter i diameter og løfte tre gange sin egen vægt.</p>
      <p>Du skal derfor være opmærksom på, at rotten snildt kan skubbe din badeværelsesrist væk, hvis den ønsker fri passage. Ligeledes har man tidligere set eksempler på, at rotten springer fra træ til tagrende. Derfor er det også her vigtigt at være opmærksom på, om det pjuskede dyr måske har utilsigtet husadgang via omkringliggende træer.</p>
      <p>Rotter kan gnave sig igennem alle materialer, som er blødere end marmor, og derfor er det også muligt for rotten at gnave sig ind i dit hjem, hvis dit hus har nogle svage punkter hist og her.</p>
      <p>Skadedyret kan både befinde sig i dine vægge og hulmure, så vær opmærksom på gnavelyde, hvin og skrig. Et tegn på rotter kan også være en skarp og generende dunst af kloak og grisestald</p>
      
      <h2>55 smitsomme sygdomme</h2>
      <p>Nu kommer vi til den lidt mere gustne viden. En enkelt rotte kan bære rundt på op til 55 sygdomme. Salmonella, smitsom leverbetændelse, Roskildesyge, stivkrampe og colibakterier er en del af den charmerende pallette, som dyret kan videregive til mennesker.</p>
      <p>Det mest alvorlige sygdom dyret kan bære rundt på, er Leptospirose-bakterien, den såkaldte Weils syge, som smitter via dyrets urin. Weils syge er en ubehagelig omgang. Sygdommen medfører både influenzalignende feber, kulderystelser, hovedpine og muskelømhed. Hvis sygdommen ikke behandles med antibiotika forholdsvis tidligt i udviklingsstadiet, kan den smittede desuden udvikle alvorlige symptomer såsom nyresvigt og gulsot.</p>
      <p>Ved skybrud er det ganske normalt at kloakkerne kan flyde over, og det medfører en smittefare, fordi rotteurinen sættes i omløb. Derfor er det vigtig, du bruger nogle gode rengøringshandsker, når du fx skal svabre kældergulvet efter et voldsomt regnskyld. Det samme gælder, hvis du skal rydde op i dit hjem efter et rottebesøg. Rotter kan være raske smittebærere af bakterien. Omvendt er det heldigvis ikke alle rotter, som er inficerede. Det er også vigtigt at have in mente, at rotter kan bære både lopper, tæger og mider.</p>
      <p>Hvis du fatter mistanke om uventet visit fra den pjuskede fætter, så kontakt Fyns Afløbsteknik ApS. Vi sørger for, at dit hjem bliver trygt igen</p>
    `
  },
  hoejvandslukke: {
    title: "Højvandslukke",
    slug: "hoejvandslukke",
    meta_title: "Højvandslukke – FYNS AFLØBSTEKNIK",
    meta_description: "Undgå vand i kælderen med et højvandslukke. Fyns Afløbsteknik sikrer din kælder, din brønd og din tryghed.",
    hero_heading: "Undgå vand i kælderen med et højvandslukke",
    hero_subheading: "Jeg sikrer din kælder, din brønd og din tryghed",
    gallery_slug: "hoejvandslukke-galleri",
    badge: "Skybrudssikring",
    image: "https://assets.auxodev.dk/assets/3ee58f8c-8fdb-408d-9efa-3b231a487177/imgi-5-flood-header2-scaled.jpg",
    htmlContent: `
      <p><strong>Et højvandslukke er ikke nødvendigvis det mest charmerende eller interessante emne. Mange mennesker ved faktisk slet ikke, hvad et højvandslukke er. Er du nysgerrig på at blive klogere? Måske ikke nødvendigvis på et højvandslukke, men snarere på hvordan du kan blive tryggere i dit hjem ved hjælp af et højvandslukke. Følg med herunder.</strong></p>
      
      <h2>Tryghed er et grundlæggende behov</h2>
      <p>Mennesket har fysiske behov, sociale behov, behov for anerkendelse og behov for selvrealisering. Derudover er et af menneskets grundlæggende behov tryghed. For det moderne, vestlige menneske kan det blandt andet betyde økonomisk eller måske forsikringsmæssig tryghed. Men ofte forbindes tryghed med hjemmet. Der hvor vi står op om morgenen. Der hvor vi går i seng. Der hvor vi er sammen med familien, fejrer højtider og griller med naboerne. Hjemmet er et helle, en komfortzone og en følelse af tryghed. Derfor er det også vigtigt, at du sikrer dit hjem mod ødelæggende og tidskrævende vandskader. Det er her, et højvandslukke kommer ind i billedet.</p>
      
      <h2>Hvorfor skal du vælge et højvandslukke?</h2>
      <p>Skæver du også bekymret mod himlen, når regnen i timevis står uregerligt ned i lårtykke stråler? Kraftige skybrud rammer især den danske sommer, og når store mængder regn falder på kort tid, betyder det ofte, at kloaksystemet fyldes, så spildevand skyder op i kældre og fra afløb.</p>
      <p>Oversvømmelse i kælderen kan medføre store omkostninger, besværlige forsikringssager og ikke mindst tab af ejendele med stor affektionsværdi. Skader på gulv, vægge, døre, paneler og inventar er en ærgerlig affære, som de færreste har kalkuleret med i en allerede travl hverdag. Som grundejer har du selv ansvaret for oversvømmelser på kælderniveau, og derfor er det helt essentielt, at du har gjort dig overvejelser om hvilke forebyggelser, markedet tilbyder.</p>
      <p>Heldigvis kan du selv forebygge en kælderoversvømmelse. Her er den bedste og oftest brugte løsning et højvandslukke installeret af en autoriseret og kyndig kloakmester.</p>
      
      <h2>Hvad er et højvandslukke egentlig?</h2>
      <p>Et højvandslukke forhindrer, at tilbageløbende kloakvand kommer op gennem afløbet og ud i din kælder. Et højvandslukke er et stykke fabrikeret afløbsledning med kontraklapper. De indbyggede klapper skaber en effektiv sluse som åbner, når spildevandet løber ud af huset. Samtidig lukker klapperne, når kloakvandet presses ind udefra. Højvandslukker findes i mange forskellige udformninger, men det mest almindelige højvandslukke monteres på hovedledningen, så samtlige ledninger er sikret. Det er også muligt at montere et gulvafløb, hvor håndvandslukket er indbygget. Et højvandslukke er en både solid, billig og effektiv løsning.</p>
      
      <h2>Et automatisk eller manuelt højvandslukke?</h2>
      <p>Et højvandslukke kan fungere både automatisk og manuelt. Det fungerer godt i de kælderniveauer, hvor afløbene sjældent er i brug. Den manuelle del af et højvandslukke virker på den måde, at det som udgangspunkt altid skal være lukket, når det ikke bruges. Når højvandslukket er lukket, vil det sikre og fastholde sikringen 100 procent.</p>
      <p>Hvis der skulle opstå et behov for bruge afløbene, kan man altid åbne det manuelt. Selvom du åbner for det manuelle højvandslukke, er du stadig sikret – der sidder nemlig en automatisk højvandslukke, som vil sætte ind, hvis der skulle blive brug for det.</p>
      
      <h2>Fyns Afløbsteknik: Autoriseret kloakmester</h2>
      <p>Bag Fyns Afløbsteknik står jeg, Morten Chylenski. Jeg arbejder som selvstændig kloakmester på Fyn og arbejder hver eneste dag med at lytte, rådgive og naturligvis fikse. Jeg er autoriseret og dedikeret, og derfor ser jeg det som min fornemmeste opgave at skræddersy løsninger til lige netop dit behov.</p>
      <p>Fyns Afløbsteknik ApS har mange års erfaring med at sikre de danske hjem i tilfælde af voldsomme skybrud. For os er det et privilegium at skabe tryghed gennem høj kvalitet, effektivitet og pålidelighed. Vi lytter til dine behov og går altid en ekstra mil for at imødekomme dine forventninger med kyndig rådgivning, produkter af høj kvalitet og specifikt tilpassede løsninger.</p>
      <p>Du behøver ikke at vide noget om højvandslukker, kloakinstallationer eller renovering. Vi guider dig gennem processen, så du altid kan mærke, at du er i trygge hænder.</p>
    `
  },
  "kloak-tv": {
    title: "Kloak TV",
    slug: "kloak-tv",
    meta_title: "Kloak TV – FYNS AFLØBSTEKNIK",
    meta_description: "Med TV-inspektion kan du få kontrolleret din kloaks tilstand. Fyns Afløbsteknik tilbyder grundig inspektion med det nyeste udstyr.",
    hero_heading: "Kloak TV",
    hero_subheading: "Med TV-inspektion kan du få kontrolleret din kloaks tilstand.",
    gallery_slug: "kloak-tv-galleri",
    badge: "TV-inspektion",
    image: "https://assets.auxodev.dk/assets/3ee58f8c-8fdb-408d-9efa-3b231a487177/imgi-5-kloaktc-header-scaled.jpg",
    htmlContent: `
      <p><strong>Med TV-inspektion kan du få kontrolleret din kloaks tilstand.</strong></p>
      <p>Med tv-inspektionen kan vi lokalisere skader på dit kloaksystem, så du undgår brud på rør, der kan føre til stoppelse af kloak, oversvømmelse og eksempelvis rotteproblemer.</p>
      <p>Hos Fyns Afløsteknik ApS tilbyder vi en grundig TV-inspektion af din kloak og du får derved mulighed for at få klarhed over kloakkens tilstand. Og vi kan altid finde den optimale løsning på problemet og forudse kommende reparationer, inden de bliver alvorlige. Dette kommer ikke kun dig til gode, men også dit forsikringsselskab, skadedyrsbekæmpere og miljømyndighederne. Se mere på bedrebyg.dk <a href="http://bedrebyg.dk/tv-inspektion/" target="_blank" rel="noopener noreferrer" class="text-neutral-900 underline hover:text-neutral-600">her</a>.</p>
      <p>Hos Fyns Afløsteknik ApS anvender vi det nyeste inspektionsudstyr, når vi inspicerer din kloak og hjælper dig med at spore defekte kloakker, rotter i kloakken, skjulte kloakledninger samt tilbagevendende problemer med afløbet.</p>
    `
  },
  punktreparation: {
    title: "Punktreparation",
    slug: "punktreparation",
    meta_title: "Punktreparation – FYNS AFLØBSTEKNIK",
    meta_description: "Punktreparation af kloakskade uden opgravning. Økonomisk fornuftigt alternativ udført af autoriseret kloakmester.",
    hero_heading: "Punktreparation",
    hero_subheading: "Punktreparation af kloakskade uden opgravning",
    gallery_slug: "punktreparation-galleri",
    badge: "Uden opgravning",
    image: "https://assets.auxodev.dk/assets/3ee58f8c-8fdb-408d-9efa-3b231a487177/imgi-5-punktrep-header-scaled.jpg",
    htmlContent: `
      <p>Punktreparation af kloakskade uden opgravning. Eksempelvis under bygninger eller steder hvor der ikke ønskes gravearbejde. Når der er tale om mindre skader på en kloakledning, kan man nøjes med at udføre en punktreparation også kaldet punktrenovering.</p>
      <p>Ved punktrenovering trækker man en ballon hen til stedet i ledningen hvor man har en defekt. Rundt om ballonen sidder et stykke væv som når ballonen blæses op til fuld størrelse, fastgører vævet på det defekte rør. Herefter kan ballonen fjernes og kloakken er nu repareret.</p>
      <p>Punktreparation er således det økonomisk mest fornuftige alternativ og som kan udsætte en egentlig renovering langt ud i tid</p>
    `
  },
  "spuling-slamsugning": {
    title: "Spuling/slamsugning",
    slug: "spuling-slamsugning",
    meta_title: "Spuling/slamsugning – FYNS AFLØBSTEKNIK",
    meta_description: "Professionel spuling og slamsugning udført af autoriseret kloakmester på Fyn. Fyns Afløbsteknik ApS.",
    hero_heading: "Spuling/slamsugning",
    hero_subheading: "Professionel spuling og slamsugning af autoriseret kloakmester",
    gallery_slug: null,
    badge: "Spuling & Slamsugning",
    image: "https://assets.auxodev.dk/assets/3ee58f8c-8fdb-408d-9efa-3b231a487177/img-1409.webp",
    htmlContent: `
      <p><strong>Er din kloak eller dit afløb stoppet? Så har du fat i den helt rigtige hjælp hos Fyns Afløbsteknik ApS.</strong></p>
      
      <h2>Autoriseret kloakmester på hele Fyn</h2>
      <p>Bag Fyns Afløbsteknik står autoriseret kloakmester Morten Chylenski. Vi hjælper private og erhverv med grundig og skånsom spuling og rensning af stoppede afløb, stikledninger og kloakrør.</p>
      <p>Vores fornemmeste opgave er at imødekomme dine forventninger ift. både topkvalitet og tillidsfuld service. Hos Fyns Afløbsteknik ApS er din kloakering i trygge hænder.</p>
      
      <h2>Professionelt udstyr til spuling og slamsugning</h2>
      <p>Med vores fuldt udstyrede servicetrailer klarer vi både spuling, slamsugning og tilhørende TV-inspektion, så årsagen til forstoppelsen lokaliseres og udbedres effektivt.</p>
      
      <h2>Kontakt Fyns Afløbsteknik</h2>
      <p>Har du akut brug for hjælp eller spørgsmål til spuling eller slamsugning, er du velkommen til at kontakte mig direkte på telefon <strong>5049 3950</strong> eller sende en e-mail på <strong>mc@fyat.dk</strong>.</p>
    `
  },
  "raad-mod-rotter": {
    title: "Råd Mod Rotter",
    slug: "raad-mod-rotter",
    meta_title: "Råd Mod Rotter – FYNS AFLØBSTEKNIK",
    meta_description: "Her er 5 gode råd, du kan følge for at sikre dig mod rotter. Læs anbefalingerne fra Fyns Afløbsteknik.",
    hero_heading: "Råd mod rotter",
    hero_subheading: "Her er 5 gode råd, du kan følge for at sikre dig mod rotter",
    gallery_slug: "raad-mod-rotter-galleri",
    badge: "Gode råd & Forebyggelse",
    image: "https://assets.auxodev.dk/assets/3ee58f8c-8fdb-408d-9efa-3b231a487177/imgi-5-rat-header-scaled.jpg",
    htmlContent: `
      <p>Med nattefrosten søger uønskede gæster i form af rotter mod huse og bygninger, for at finde lune steder at bygge reder. Og det kan nemt blive noget, du mærker til i den kommende tid. Det skriver Skadedyrskontrollen Rentokil.</p>
      
      <h2>Vores råd</h2>
      <p>– Det vi ser lige nu er, at de lave temperaturer presser rotterne indenfor, fordi de har svært ved at klare sig i vinterkulden. Det er faktisk endnu mere udpræget netop nu, for antallet af rotter i Danmark har været i vækst i mange år, og der er intet, der tyder på, det er på vej til at ændre sig. Snarere tværtimod, fortæller Claus Schultz, der er teknisk chef i Rentokil Skadedyrskontrol og formand for Brancheforeningen for Skadedyrsfirmaer. Her er 5 gode råd, du kan følge:</p>
      
      <ul>
        <li>Begræns mængden af fuglemad i haver og gårde for at mindske tiltrækningen af rotter.</li>
        <li>Tilse bygninger for blandt andet revner, sprækker og huller. Rotter er stort set altædende og kan gnave sig igennem alle materialer blødere end marmor, klemme sig ind af et hul på størrelse med en tokrone og løfte en rist, som vejer 1,5 kg.</li>
        <li>Tilse bygninger for blandt andet revner, sprækker og huller. Rotter er stort set altædende og kan gnave sig igennem alle materialer blødere end marmor, klemme sig ind af et hul på størrelse med en tokrone og løfte en rist, som vejer 1,5 kg.</li>
        <li>Kontroller at rør og afløbsbrønde er tætte og i god stand – eventuelt med hjælp fra en kloakmester eller en skadedyrsbekæmper.</li>
        <li>Hold din ejendom ren og ryddelig, så rotter ikke kan finde skjulesteder og fødeemner. Sørg altid for at opbevare skrald i beholdere med tætsluttende låg.</li>
      </ul>
    `
  },
  "om-fyns-afloebsteknik": {
    title: "Om Fyns Afløbsteknik",
    slug: "om-fyns-afloebsteknik",
    meta_title: "Om Fyns Afløbsteknik – FYNS AFLØBSTEKNIK",
    meta_description: "Læs mere om Fyns afløbsteknik og hvad autoriseret kloakmester Morten Chylenski kan gøre for dig.",
    hero_heading: "Rottestop med en rottespærre",
    hero_subheading: "Kloakmester Morten sikrer dit hjem",
    gallery_slug: "firma-galleri",
    badge: "Autoriseret Fagmand",
    image: "https://assets.auxodev.dk/assets/3ee58f8c-8fdb-408d-9efa-3b231a487177/img-1409.webp",
    htmlContent: `
      <p><strong>Måske er afløbsteknik ikke det emne, du beskæftiger dig allermest med. Til trods for at det er noget, vi alle har gavn og glæde af hver eneste dag, så er det ikke et vidensområde, som den gængse dansker ved så meget om.</strong></p>
      <p>Det er derfor vigtigt, du finder en autoriseret kloakmester, som har fuldstændig styr på faget, og som kombinerer sine ydelser med tillidsfuld service. Fyns Afløbsteknik sikrer dit hjem efter alle kunstens regler.</p>
      
      <h2>Service og kvalitet</h2>
      <p>Hos Fyns Afløbsteknik ApS har vi mange års erfaring med at sikre de danske hjem mod rotter. Rotter udgør ikke blot en sundhedsfare, men medfører også store skader på dine kloakrør. I værste fald kan den pjuskede fætter undergrave dit hjem eller dine erhvervsbygninger.</p>
      <p>Det er her, Fyns Afløbsteknik ApS kommer ind i billedet. Ved at indsætte en rottespærre i dine kloakrør, afskærer vi rottens passage fuldstændigt. Det er vigtigt, rottespærren monteres så tæt på hovedledningen som overhovedet muligt, så den må vende om i god afstand til bygningen. Som autoriseret kloakmester kan Fyns Afløbsteknik ApS klare arbejdet for dig, så det bliver gjort helt rigtigt fra start.</p>
      <p>Vores fornemmeste opgave er at imødekomme dine forventninger ift. både topkvalitet og tillidsfuld service. Hos Fyns Afløbsteknik ApS er din kloakering i trygge hænder.</p>
      
      <h2>Jeg lytter, rådgiver og fikser</h2>
      <p>Hjemmet skal helst være hverdagens trygge base. Det er her, vi byder dagen velkommen, og det er ligeledes her, vi siger farvel til den. Det er her, vi samles med den højrøstede familie, og det er her, vi nyder et stille øjeblik i eget selskab. Det er her, vi flader ud foran fjernsynet, og det er her, vi hopper ind i det nye år med ønsket om fremtidig glæde og tryghed. Hjemmet danner rammen om vores liv, og det er derfor helt essentielt, vi føler os trygge, når vi befinder os i det.</p>
      
      <h2>Hvad kan Morten hjælpe dig med?</h2>
      <p>Jeg er både autoriseret og dedikeret, og min faglighed spænder derfor bredt. Min fornemmeste opgave er at imødekomme dine forventninger ift. både topkvalitet og tillidsfuld service. Jeg er specialiseret inden for rottesikring, kloak tv, højvandslukke og punktreparation. Hos Fyns Afløbsteknik er din kloakering derfor i sikre hænder.</p>
      
      <h3>Rottesikring med rottespærre</h3>
      <p>Har du mistanke om rotter i din afløb eller i dit toilet? Fyns Afløbsteknik er autoriseret ekspert i rottesikring. Rotter udgør ikke blot en alvorlig sundhedsfare, men ødelægger også din kloakering. Den lille pjuskede fætter kan i værste fald undergrave dit hjem, fordi invaderingen kan være enormt massiv. Ved at montere en rottespærre i dine kloakrør, afskæres rottens passage til dit hjem fuldstændigt. Det er vigtigt, at spærren sidder helt rigtigt, så dit hjem sikres på bedste vis. Fyns Afløbsteknik klarer monteringen for dig, så det bliver gjort helt rigtigt fra starten.</p>
      <p>Læs mere om rottesikring og rottens færden lige <a href="/rottespaerre" class="text-neutral-900 font-bold underline hover:text-neutral-600">her</a></p>
      
      <h3>Kloak TV</h3>
      <p>Fyns Afløbsteknik er specialiseret i kloak-tv, og derfor kan jeg tilbyde en grundig tv-inspektion af din kloak. Med en tv-inspektion er det muligt at lokalisere skader på dit kloaksystem, så du undgår brud på dine rør. Et brud kan både medføre stoppelse af kloak, oversvømmelse og store problemer med rotter.</p>
      <p>Læs mere om kloak tv lige <a href="/kloak-tv" class="text-neutral-900 font-bold underline hover:text-neutral-600">her</a></p>
      
      <h3>Højvandslukke</h3>
      <p>Bøvler du sommetider med vand i kælderen? Her er det vigtigt at huske, at det altid er billigere at forebygge end at reparere. Fyns Afløbsteknik rykker ofte ud efter skybrud, og jeg ved derfor, hvor ødelæggende det kan være for dine ellers trygge rammer. Et højvandslukke forhindrer, at tilbageløbende kloakvand kommer op gennem dit afløb og derefter ud i din kælder. Det gør det ved hjælp af en kontraklapper, som sørger for at spildevandet ikke presses retur. Et højvandslukke er både en solid og billig løsning, og som autoriseret kloakmester kan Fyns Afløbsteknik hurtigt sikre dit hjem.</p>
      <p>Læs mere om et højvandslukke lige <a href="/hoejvandslukke" class="text-neutral-900 font-bold underline hover:text-neutral-600">her</a></p>
      
      <h3>Punktreparation</h3>
      <p>Det kan være omfattende at reparere en kloakskade, hvis der ikke ønskes en opgravning. Med en punktreparation er det dog ganske overskueligt at fikse en kloakskade, og den kan samtidig udskyde en omfattende renovering med mange år. Med præcision kan Fyns Afløbsteknik udføre et kvalitetsbevidst stykke arbejde under jorden, som både er fordelagtigt for din mavefornemmelse og din pengepung.</p>
      <p>Læs mere om punktreparation lige <a href="/punktreparation" class="text-neutral-900 font-bold underline hover:text-neutral-600">her</a></p>
      
      <h2>Kontakt Fyns Afløbsteknik</h2>
      <p>Konntakt Fyns Afløbsteknik for en uforpligtende snak. Jeg overholder altid aftalte priser, betingelser og tidsfrister og leverer den kvalitet, dit hjem fortjener. Fyns Afløbsteknik ligger i Odenses nordøstligste bydel. Herfra kan jeg nå alle de fynske flækker. Fyns Afløbsteknik V. Morten Chylenski Brolandvej 78 5320 Agerup CVR: 40617361</p>
      <p>Du er hjerteligt velkommen til at ringe til mig på telefon <strong>5049 3950</strong> eller sende mig en e-mail på <strong>mc@fyat.dk</strong>. Så finder vi en løsning til lige netop dig.</p>
    `
  }
};

export default function ServiceDetail({ explicitSlug }) {
  const params = useParams();
  const currentSlug = explicitSlug || params.slug;
  const pageData = SERVICES_DATA[currentSlug] || SERVICES_DATA["rottespaerre"];

  const [cmsContent, setCmsContent] = useState(null);

  // Load dynamically from CMS endpoint if updated by editor
  useEffect(() => {
    let isMounted = true;
    async function loadCmsService() {
      try {
        const res = await fetch("https://api.dev.auxo.dk/public/content/services");
        if (res.ok) {
          const items = await res.json();
          if (Array.isArray(items)) {
            const match = items.find((i) => i.service_slug === currentSlug);
            if (match && isMounted) {
              setCmsContent(match);
            }
          }
        }
      } catch {
        // use verbatim fallback
      }
    }

    loadCmsService();
    return () => {
      isMounted = false;
    };
  }, [currentSlug]);

  // Set document title verbatim
  useEffect(() => {
    document.title = cmsContent?.meta_title || pageData.meta_title;
  }, [cmsContent, pageData]);

  const activeData = {
    ...pageData,
    hero_heading: cmsContent?.hero_heading || pageData.hero_heading,
    hero_subheading: cmsContent?.hero_subheading || pageData.hero_subheading,
    content: cmsContent?.content || pageData.htmlContent,
    gallery_slug: cmsContent?.gallery_slug || pageData.gallery_slug,
    image: (cmsContent?.image && cmsContent.image[0]) || pageData.image
  };

  return (
    <div className="bg-white min-h-screen text-neutral-900">
      {/* Subpage Hero Header */}
      <section className="relative bg-[#0d1117] text-white py-14 sm:py-20 border-b border-neutral-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl space-y-4">
            <div className="flex items-center gap-2 text-xs uppercase tracking-widest text-neutral-400 font-bold">
              <Link to="/" className="hover:text-white transition-colors">Forside</Link>
              <span className="text-neutral-600">/</span>
              <span>{activeData.title}</span>
            </div>

            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-white">
              {activeData.hero_heading}
            </h1>

            {activeData.hero_subheading && (
              <p className="text-lg sm:text-xl font-medium text-neutral-300 border-l-4 border-neutral-400 pl-4 py-0.5">
                {activeData.hero_subheading}
              </p>
            )}

            <div className="pt-2 flex flex-wrap items-center gap-4 text-xs text-neutral-400">
              <span className="flex items-center gap-1.5 text-neutral-300 font-semibold">
                <i className="fa-solid fa-shield-halved text-neutral-400" aria-hidden="true" />
                <span>Aut. Kloakmester Morten Chylenski</span>
              </span>
              <span>•</span>
              <a href="tel:50493950" className="text-white hover:text-neutral-300 font-bold flex items-center gap-1 no-break">
                <i className="fa-solid fa-phone text-neutral-400" aria-hidden="true" />
                <span className="no-break">50 49 39 50</span>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content Layout */}
      <section className="py-14 sm:py-20 bg-neutral-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
            
            {/* Hovedtekst: Verbatim fra scrapet */}
            <div className="lg:col-span-8 bg-white p-6 sm:p-10 rounded-2xl border border-neutral-200 shadow-sm space-y-8">
              
              {/* Fremhævet billede for ydelsen */}
              {activeData.image && (
                <div className="rounded-xl overflow-hidden shadow border border-neutral-200 aspect-16/9 bg-neutral-900">
                  <img
                    src={
                      activeData.image.includes("imgi-") || activeData.image.includes("fynsafloebsteknik")
                        ? activeData.image
                        : `https://assets.auxodev.dk/cdn-cgi/image/width=1000,quality=85,format=auto/${activeData.image.replace("https://assets.auxodev.dk/", "")}`
                    }
                    alt={activeData.title}
                    className="w-full h-full object-cover"
                  />
                </div>
              )}

              {/* Verbatim Brødtekst */}
              <div
                className="prose service-content rich-text-content max-w-none"
                dangerouslySetInnerHTML={{ __html: activeData.content }}
              />

              {/* Kloak-TV: TV-inspektionsvideo optaget fra kloakrør */}
              {currentSlug === "kloak-tv" && (
                <div className="my-8 pt-6 border-t border-neutral-200">
                  <div className="mb-4">
                    <span className="text-xs font-bold uppercase tracking-wider text-neutral-500 block mb-1">
                      Videooptagelse
                    </span>
                    <h3 className="text-xl sm:text-2xl font-bold text-neutral-900">
                      Kameraoptagelse fra kloakrør
                    </h3>
                    <p className="text-sm text-neutral-600 mt-1">
                      Konkret optagelse fra inspektionskamera under gennemgang af et kloakrør.
                    </p>
                  </div>

                  <div className="rounded-xl overflow-hidden border border-neutral-200 bg-neutral-950 shadow-md">
                    <video
                      controls
                      playsInline
                      preload="metadata"
                      className="w-full max-h-[480px] bg-black mx-auto aspect-video"
                    >
                      <source
                        src="https://assets.auxodev.dk/assets/3ee58f8c-8fdb-408d-9efa-3b231a487177/230627-0845a-fyat.mp4"
                        type="video/mp4"
                      />
                      Din browser understøtter ikke HTML5-videoafspilning.
                    </video>
                  </div>
                </div>
              )}

              {/* Punktreparation: Før- og Efter-par */}
              {currentSlug === "punktreparation" ? (
                <BeforeAfterPairs />
              ) : (
                /* Teknisk CMS Galleri Reference */
                activeData.gallery_slug && (
                  <Gallery gallerySlug={activeData.gallery_slug} />
                )
              )}

              {/* Direkte CTA knapper nederst på teksten */}
              <div className="pt-6 border-t border-neutral-200 flex flex-col sm:flex-row items-center justify-between gap-4 bg-neutral-50 p-6 rounded-xl">
                <div>
                  <h4 className="font-extrabold text-neutral-900 text-base">
                    Har du brug for hjælp til {activeData.title.toLowerCase()}?
                  </h4>
                  <p className="text-xs text-neutral-600 mt-0.5">
                    Få et uforpligtende tilbud eller rådgivning direkte fra autoriseret kloakmester.
                  </p>
                </div>
                <div className="flex items-center gap-3 shrink-0">
                  <a
                    href="tel:50493950"
                    className="bg-neutral-900 hover:bg-black text-white font-bold px-5 py-2.5 rounded text-sm shadow transition-colors flex items-center gap-2 no-break"
                  >
                    <i className="fa-solid fa-phone text-neutral-400" aria-hidden="true" />
                    <span className="no-break">50 49 39 50</span>
                  </a>
                  <Link
                    to="/kontakt"
                    className="bg-neutral-200 hover:bg-neutral-300 text-neutral-900 font-semibold px-4 py-2.5 rounded text-sm transition-colors"
                  >
                    Kontakt os
                  </Link>
                </div>
              </div>

            </div>

            {/* Sidebar med kontakt, certifikation og andre ydelser */}
            <aside className="lg:col-span-4 space-y-8 lg:sticky lg:top-24 lg:max-h-[calc(100vh-7rem)] lg:overflow-y-auto lg:overscroll-contain pr-1 custom-scrollbar">
              
              {/* Hurtig kontakt boks */}
              <div className="bg-[#0f141c] text-white p-6 rounded-xl border border-neutral-800 shadow-md">
                <div className="flex items-center gap-3 mb-4 pb-3 border-b border-neutral-800">
                  <img
                    src="https://assets.auxodev.dk/assets/3ee58f8c-8fdb-408d-9efa-3b231a487177/cropped-fyat-logo-1-180x180.png"
                    alt="Logo"
                    className="h-10 w-10 object-contain rounded brightness-0 invert opacity-75 contrast-125 transition-all duration-200"
                    style={{ filter: "brightness(0) invert(0.8) contrast(1.1)" }}
                  />
                  <div>
                    <h3 className="font-extrabold text-sm text-white">
                      Fyns Afløbsteknik ApS
                    </h3>
                    <span className="text-xs text-neutral-400">v/ Morten Chylenski</span>
                  </div>
                </div>

                <p className="text-xs text-neutral-300 leading-relaxed mb-4">
                  Jeg står klar til at rådgive og udføre arbejdet til aftalt tid og pris overalt på Fyn.
                </p>

                <div className="space-y-3 text-xs mb-6">
                  <div className="flex items-center gap-2.5">
                    <i className="fa-solid fa-phone text-neutral-400" aria-hidden="true" />
                    <a href="tel:50493950" className="font-bold text-white text-sm hover:underline no-break">
                      50 49 39 50
                    </a>
                  </div>
                  <div className="flex items-center gap-2.5">
                    <i className="fa-solid fa-envelope text-neutral-400" aria-hidden="true" />
                    <a href="mailto:mc@fyat.dk" className="text-neutral-200 hover:text-white no-break">
                      mc@fyat.dk
                    </a>
                  </div>
                  <div className="flex items-start gap-2.5">
                    <i className="fa-solid fa-location-dot text-neutral-400 mt-0.5" aria-hidden="true" />
                    <span className="text-neutral-300">Brolandvej 78, 5320 Agedrup</span>
                  </div>
                  <div className="flex items-center gap-2.5">
                    <i className="fa-solid fa-id-card text-neutral-400" aria-hidden="true" />
                    <span className="text-neutral-400">CVR: 40617361</span>
                  </div>
                </div>

                <a
                  href="tel:50493950"
                  className="w-full bg-white hover:bg-neutral-200 text-black font-extrabold py-3 px-4 rounded text-center block text-sm transition-colors shadow no-break"
                >
                  <i className="fa-solid fa-phone mr-2" aria-hidden="true" />
                  <span className="no-break">Ring 50 49 39 50</span>
                </a>
              </div>

              {/* Certifikation & Kontrolinstans */}
              <div className="bg-white p-6 rounded-xl border border-neutral-200 shadow-sm">
                <h3 className="font-extrabold text-sm text-neutral-900 mb-3 uppercase tracking-wider text-xs">
                  Certifikation & Sikkerhed
                </h3>
                <div className="bg-neutral-50 p-3 rounded-lg border border-neutral-200 text-center mb-3">
                  <img
                    src="/images/validan-logo.svg"
                    alt="Validan Kontrolinstans"
                    className="h-10 mx-auto object-contain"
                  />
                </div>
                <p className="text-xs text-neutral-600 leading-relaxed">
                  Godkendt af Sikkerhedsstyrelsen som kontrolinstans inden for autorisationsområdet kloak.
                </p>
              </div>

              {/* Andre Ydelser Navigation */}
              <div className="bg-white p-6 rounded-xl border border-neutral-200 shadow-sm">
                <h3 className="font-extrabold text-sm text-neutral-900 mb-3 tracking-wide">
                  Se øvrige ydelser
                </h3>
                <ul className="space-y-2 text-xs sm:text-sm">
                  {Object.entries(SERVICES_DATA).map(([key, item]) => {
                    const isCurrent = key === currentSlug;
                    return (
                      <li key={key}>
                        <Link
                          to={`/${key}`}
                          className={`p-2.5 rounded flex items-center justify-between transition-colors ${
                            isCurrent
                              ? "bg-neutral-900 text-white font-bold"
                              : "text-neutral-700 hover:bg-neutral-100 hover:text-neutral-900"
                          }`}
                        >
                          <span>{item.title}</span>
                          <i className="fa-solid fa-chevron-right text-xs" aria-hidden="true" />
                        </Link>
                      </li>
                    );
                  })}
                </ul>
              </div>

            </aside>

          </div>
        </div>
      </section>

      {/* Kontaktformular Sektion */}
      <section className="py-16 bg-white border-t border-neutral-200">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <ContactForm
            title={`Få et tilbud på ${activeData.title.toLowerCase()}`}
            subtitle="Send en uforpligtende besked, så kontakter Morten dig hurtigst muligt med vejledning og pris."
          />
        </div>
      </section>
    </div>
  );
}
